import { useNavigate } from 'react-router-dom'
import {
  Typography,
  Container,
  Box,
  Card,CardContent,
} from '@mui/material/';
import Grid from '@mui/material/Grid2';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import Pjdb1Button from '../components/inputs/Pjdb1Button';

const FAQ_DIVS = [
  {
    KEY : "COMMON",
    NAME : "共通",
  },
  {
    KEY : "WORK",
    NAME : "対象物DB",
  },
];
const FAQS = [
  {
    DIV : "COMMON",
    QUESTION : "「登録」画面のクリアを押すとどうなりますか？",
    ANSWER : "入力フォームに入力されている情報がクリアされます。<BR>クリアしてもDBに登録されているデータには影響ないです。",
  },
  {
    DIV : "WORK",
    QUESTION : "「対象物一覧」と「登録済み対象物一覧」の違いは？",
    ANSWER : "「対象物一覧」では対象物DBに登録されているワークの検索が出来ます。<BR>一方「登録済み対象物一覧」では自身の所属する組織の登録したワークの検索が出来て、以前登録されたワークの確認や別サンプル、別モデルの登録、修正が簡易に出来ます。",
  },
];
export default function Faq() {
  const navigate = useNavigate();

  return (
    <>
      <Box component="section" sx={{ textAlign:"center", mt:4 }}>
        <Typography variant="h5" color="primary.main">
          FAQ
        </Typography>
        <Typography variant="h6">
          よくあるご質問
        </Typography>
      </Box>

      <Container maxWidth="md" sx={{ mt:1 }}>
        {FAQ_DIVS.map((DIVS) => (
          <>
            <Grid key={DIVS.KEY} container alignItems="center" sx={{mt:4}}>
              <ArrowForwardIosIcon style={{ fontSize: "23px"}} />
              <Grid>
                <Typography variant="h6" sx={{ml:1}}>
                  { DIVS.NAME }
                </Typography>
              </Grid>
            </Grid>
            {FAQS.filter(FAQ=>FAQ.DIV===DIVS.KEY).map((FAQ) => (
              <Card key={FAQ.QUESTION} sx={{mt:2}}>
                <CardContent sx={{backgroundColor:"primary.main", color:"white", p:1}}>
                  <Grid container spacing={1} alignItems="flex-start" sx={{flexWrap:"nowrap"}}>
                    <Grid sx={{ width:"40px", flexShrink:0, textAlign:"center" }}>
                      <Typography variant="body1" sx={{fontSize:"1.3rem",m:0}}>Q</Typography>
                    </Grid>
                    <Grid sx={{flexGrow: 1, mt:0.7}}>
                      <Typography variant="body1" sx={{m:0}} dangerouslySetInnerHTML={{ __html: String(FAQ.QUESTION) }} />
                    </Grid>
                  </Grid>
                </CardContent>
                <CardContent sx={{p:1, paddingBottom:"8px !important"}}>
                  <Grid container spacing={1} alignItems="flex-start" sx={{flexWrap:"nowrap"}}>
                    <Grid sx={{ width:"40px", flexShrink:0, textAlign:"center" }}>
                      <Typography variant="body1" sx={{fontSize:"1.3rem",m:0}}>A</Typography>
                    </Grid>
                    <Grid sx={{flexGrow: 1, mt:0.7}}>
                      <Typography variant="body1" sx={{m:0}} dangerouslySetInnerHTML={{ __html: String(FAQ.ANSWER) }} />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            ))}
          </>
        ))}

      </Container>
      <Box component="section" sx={{ textAlign:"center", mt:3 }}>
        <Pjdb1Button
          label="戻る"
          variant="contained"
          color="inherit"
          sx={{m:1}}
          onClick={()=>navigate(-1)}
        />
      </Box>
    </>
  )
}
